import React, { ReactNode } from 'react';

interface ContentSpacerProps {
    children: ReactNode;
    spacingFactor?: number;
}

export const ContentSpacer: React.FC<React.PropsWithChildren<ContentSpacerProps>> = ({ children, spacingFactor = 2 }) => {
    const marginTop = spacingFactor * 8;

    return (
        <>
            {React.Children.toArray(children)
                .filter((x) => !!x)
                .map((child, index) =>
                    <div key={index} style={index !== 0 ? { marginTop: `${marginTop}px` } : { }}>
                        {child}
                    </div>
                )}
        </>
    );
}
